import "../css/package.css";
import { Card, Col, Container, Row } from "react-bootstrap";

import rice from "../assets/rice.jpg";
import dal from "../assets/daal.jpg";
// import sabji from "../assets/specialsabji.jpg";
// import specialsabji from "../assets/specialsabji1.jpg";
import roti from "../assets/roti.png";
import puri from "../assets/puri.jpg";
import dahiwada from "../assets/dahiwada.jpeg";
import manchurian from "../assets/manchurian.jpg";
import mirchibhaje from "../assets/mirchibhaje.jpg";
import salad from "../assets/sala.jpg";
import soup from "../assets/soup.jpg";
import kabab from "../assets/kabab.jpg";
import kolhapuri from "../assets/kolhapuri.jpeg";
import gulabjamun from "../assets/gulabjamun.jpg";
import gajarhalwa from "../assets/gajarhalwa.jpg";
import paneer from "../assets/paneer.webp";
import { useEffect } from "react";
import Aos from "aos";

function GoldenPackage() {

     useEffect(() => {
        Aos.init({ duration: 1000 })
    })


  const dishes = [
    { title: "Starter 1", img: soup, items: ["Tomato Soup", "Jaljira / Aam Panha", "Chai / Coffee"] },
    { title: "Starter 2", img: kabab, items: ["Veg 65 Dry", "Hara Bhara Kabab", "Dry Manchurian"] },
    { title: "Special Sabji - 1", img: paneer, items: ["Paneer", "Shahi / Palak Paneer", "Paneer Butter Masala"] },
    { title: "Special Sabji - 2", img: kolhapuri, items: ["Mix Veg", "Aaloo Chole / Patodi", "Veg Kolhapuri"] },
    { title: "Rice", img: rice, items: ["Jira Rice (Shriram)", "Masala Rice (Basmati)"] },
    { title: "Dal", img: dal, items: ["Dal Fry", "Dal Bhaji", "Simple Dal"] },
    { title: "Sweet - 1", img: gulabjamun, items: ["Gulab Jamun", "Khawa Poli"] },
    { title: "Sweet - 2", img: gajarhalwa, items: ["Chamcham / Kala Jamun", "Gajar Halwa", "Moong Dal Halwa"] },
    { title: "Roti", img: roti, items: ["Fulka Roti (on Spot)", "Sadi Roti", "Oil Roti"] },
    { title: "Puri", img: puri, items: ["Palak Puri", "Masala Puri", "Sadgi Puri"] },
    { title: "Curd & Pakoda", img: dahiwada, items: ["Boondi Raita", "Aaloo Chat", "Dahi Bhalla"] },
    { title: "Chinese Items", img: manchurian, items: ["Noodles", "Manchurian", "M.S. Dosa"] },
    { title: "Special Dish", img: mirchibhaje, items: ["Moong Pakoda", "Kande Bhaje", "Mirchi Bhaje"] },
    { title: "Salad", img: salad, items: ["Green Salad", "Aachar & Papad", "Filter Water"] },
  ];

  return (
    <Container className="silver-section">
      <p
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "30px",
        }}
      >
        Golden Package of Rs 1,25,000/- for 500 Guests (Hall / Lawn + Catering)
      </p>

      <Row className="g-4">

        {dishes.map((dish, index) => (

          <Col key={index} xs={12} sm={6} md={4} lg={3}>
            
            <Card className="silver-card h-100">
              <Card.Img variant="top" src={dish.img} className="silver-img" />
              <Card.Body>
                <Card.Title className="silver-title">{dish.title}</Card.Title>
                {dish.items.map((item, i) => (
                  <p key={i} className="silver-item">{item}</p>
                ))}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <h2 id="silvernote">Note: Extra Charges for Decoration</h2>
    </Container>
  );
}

export default GoldenPackage;
